var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between card-module-header",on:{"click":_vm.toggleCollapse}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t(`profile.tabs.${_vm.moduleName}`))+" ")]),_c('span',{staticClass:"arrow-color"},[_c('i',{class:['fas fa-md', _vm.state ? 'fa-angle-up' : 'fa-angle-down']})])])
}
var staticRenderFns = []

export { render, staticRenderFns }